import {Component, EventEmitter, Input, Output, computed, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatBadgeModule} from '@angular/material/badge';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import {ISupportRequest} from '../../../../../interfaces/player/ISupportRequest';
import {TicketCardComponent} from '../ticket-card/ticket-card.component';

export type KanbanColumnType = 'unassigned' | 'assigned' | 'my-work' | 'escalated' | 'resolved';

@Component({
  selector: 'app-kanban-column',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    TicketCardComponent
  ],
  templateUrl: './kanban-column.component.html',
  styleUrl: './kanban-column.component.scss'
})
export class KanbanColumnComponent {
  @Input({required: true}) title!: string;
  @Input() tickets: ISupportRequest[] = [];
  @Input() isLoading = false;
  @Input() selectedTicketId: string | null = null;
  @Input() icon = 'list';
  @Input() emptyMessage = 'No tickets';

  // Using signal input for columnType to enable computed
  columnType = input.required<KanbanColumnType>();

  // Computed signal for column color class
  columnColorClass = computed(() => {
    switch (this.columnType()) {
      case 'unassigned': return 'column-unassigned';
      case 'assigned': return 'column-assigned';
      case 'my-work': return 'column-my-work';
      case 'escalated': return 'column-escalated';
      case 'resolved': return 'column-resolved';
      default: return '';
    }
  });

  @Output() ticketClicked = new EventEmitter<ISupportRequest>();
  @Output() assignToMe = new EventEmitter<ISupportRequest>();

  onTicketClicked(ticket: ISupportRequest): void {
    this.ticketClicked.emit(ticket);
  }

  onAssignToMe(ticket: ISupportRequest): void {
    this.assignToMe.emit(ticket);
  }
}
